import { Form } from 'react-bootstrap';
import Select from '../../Select';
import _ from 'lodash';
import { BUSINESS_PRODUCT_TYPE, BUSINESS_TYPE_CODE } from '../../../constants';
import { ConfigInfoSectionProps } from '../LaunchingForm.types';

const ConfigInfoSection = ({
  errors,
  formData,
  onFieldChange,
  validateField,
}: ConfigInfoSectionProps) => {
  return (
    <div className=''>
      <div className='mx-3'>
        <Form.Row>
          <Form.Group className='col mb-2'>
            <Select
              as='select'
              custom
              label='Type de restaurant'
              id='businessType'
              value={formData.configurations.businessType}
              onChange={(e) => onFieldChange('configurations.businessType', e.target.value)}
              onBlur={(e) => validateField('configurations.businessType', e.target.value)}
              error={!!errors.configurations?.businessType}
              required
              fullWidth
              name='businessType'
            >
              <option value='' disabled>
                À choisir
              </option>
              {BUSINESS_TYPE_CODE &&
                _.keys(BUSINESS_TYPE_CODE).map(key => (
                  <option key={key} value={key}>
                    {key}
                  </option>
                ))}
            </Select>
          </Form.Group>
          <Form.Group className='col mb-2'>
            <Select
              as='select'
              custom
              label='Type de produits'
              id='businessProductType'
              value={formData.configurations.businessProductType}
              onChange={(e) => onFieldChange('configurations.businessProductType', e.target.value)}
              onBlur={(e) => validateField('configurations.businessProductType', e.target.value)}
              error={!!errors.configurations?.businessProductType}
              required
              fullWidth
              name='businessProductType'
            >
              <option value='' disabled>
                À choisir
              </option>
              {BUSINESS_PRODUCT_TYPE &&
                _.values(BUSINESS_PRODUCT_TYPE).map(key => (
                  <option key={key} value={key}>
                    {key}
                  </option>
                ))}
            </Select>
          </Form.Group>
        </Form.Row>
      </div>
    </div>
  );
};

export default ConfigInfoSection;
